import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { EditionAction } from '@finect/tabular-components/EditionActions';

/* eslint-disable */
export const EntryContent = styled.div`
  position: relative;
  ${({ main }) => main && 'min-height: 90px;'};
  padding: ${({ main }) => (main ? '36px 30px 36px 72px' : '24px 30px')};

  ${({ main, theme }) =>
    main
      ? `
    &:after {
      position: absolute;
      top: 30px;
      bottom: 30px;
      left: 39.5px;
      border: 2.5px solid ${theme.mainColor};
      border-radius: 2.5px;
      content: '';
      background-color: ${theme.mainColor};
    }
  `
      : null};

  ${maxMediaQueries.phablet`
    padding: ${({ main, isEditable, hasBadge }) =>
      main && !isEditable
        ? '24px 15px 24px 36px'
        : main && isEditable
        ? '51px 15px 24px 36px'
        : hasBadge
        ? '48px 15px 24px'
        : '24px 15px'};
    ${({ main, isEditable }) => (main && isEditable ? 'margin-top: 21px;' : null)}

    ${({ main, isEditable }) => {
      if (main) {
        return `
          &:after {
            top: ${isEditable ? '54px' : '24px'};
            bottom: 24px;
            left: 15px;
          }
      `;
      }
    }};
  `};

  ${/*sc-sel*/ EditionAction} {
    ${maxMediaQueries.phablet`
      transform: ${({ main }) =>
        main ? 'translateX(-15px)' : 'translateY(-100%) translateY(-15px) translateX(-15px)'};
    `};
  }
`;
/* eslint-enable */

// TODO Delete transform when tabular fixes editor buttons position on mobile
